/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `without_influence` - bez vlivu kulturního prostředí nebo jiných životních podmínek * `cultural_environment` - SVP vyplývají převážně z kulturního prostředí žáka * `life_conditions` - SVP vyplývají převážně z dopadu jiných životních podmínek žáka do vzdělávání * `multiple_factors` - SVP vyplývají z více faktorů uvedených pod body K a Z * `evaluation_of_seven_key_areas` - Hodnocení sedmi sledovaných oblastí / faktorů
 */
export type ChildProfileDetailSocialCategoryDisadvantageEnum = 'without_influence' | 'cultural_environment' | 'life_conditions' | 'multiple_factors' | 'evaluation_of_seven_key_areas';

export const ChildProfileDetailSocialCategoryDisadvantageEnum = {
    WithoutInfluence: 'without_influence' as ChildProfileDetailSocialCategoryDisadvantageEnum,
    CulturalEnvironment: 'cultural_environment' as ChildProfileDetailSocialCategoryDisadvantageEnum,
    LifeConditions: 'life_conditions' as ChildProfileDetailSocialCategoryDisadvantageEnum,
    MultipleFactors: 'multiple_factors' as ChildProfileDetailSocialCategoryDisadvantageEnum,
    EvaluationOfSevenKeyAreas: 'evaluation_of_seven_key_areas' as ChildProfileDetailSocialCategoryDisadvantageEnum
};